var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }